module.exports = __webpack_public_path__ + "static/media/Active.35bcdd2a.png";